import React from 'react';
import styles from './LanguageSwitcher.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export default () => {
    const { i18n } = useTranslation();
    const onLanguageChange = (lang: string) => {
        i18n.changeLanguage(lang);
    };

    return (
        <div className={styles.container}>
            <Lang onLanguageChange={onLanguageChange} lang='pl' />
            <Separator />
            <Lang onLanguageChange={onLanguageChange} lang='en' />
        </div>
    );
};

interface LangProps {
    onLanguageChange: (lang: string) => void;
    lang: string;
}

const Lang = (props: LangProps) => {
    const { i18n } = useTranslation();
    const isActive = props.lang === i18n.languages[0];

    return (
        <button
            className={classNames(styles.lang, isActive && styles.langActive)}
            type='button'
            onClick={(e) => props.onLanguageChange(props.lang)}>
            {props.lang.toUpperCase()}
        </button>
    );
};

const Separator = () => <span className={styles.separator} />;
